import {datetime, Schema} from 'simpli-web-sdk'
import DeliveryCsvNotasEmAtraso from '@/model/resource/DeliveryCsvNotasEmAtraso'
import * as Helpers from '@/helpers'

export default (model: DeliveryCsvNotasEmAtraso): Schema => ({

    idCargaPk : {
        content: model && model.idCargaPk,
    },

    nroNotaFiscal: {
        content: Helpers.formatScientificNumber(model.nroNotaFiscal),
    },

    nroCte: {
        content: model && model.nroCte,
    },

    danfe: {
        content: Helpers.formatScientificNumber(model.danfe) || '',
    },

    dataCriacao: {
        content: model && datetime(model.dataCriacao),
    },

    dataPrevisao: {
        content: model && datetime(model.dataPrevisao),
    },

    slaDias: {
        content: model.slaDias || '0',
    },

    slaByDiasAtraso: {
        content: model.slaByDiasAtraso,
    },

    diasAtraso: {
        content: model.diasAtraso && (model.diasAtraso > 0) ? model.diasAtraso : '1',
    },

})
